export default __webpack_public_path__ + "3f78863.png";